'use client';

import _slicedToArray from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import * as React from 'react';
import { createContext } from '~logic/lib/react';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";

// * CONTEXT
// as some of our apps are generic builds & the company (brand/branch) is decided at runtime
// we need to fire a "lookup" Q to the BE as one of the first things after the customer requests the page
// from that Q we should get the company we are rendering the app for (based on the URL customer entered)
// and more info (like order origin, sector, ...)
// that Q is called a (Company)Lookup and this global provider should store its result
// because we will need this info in multiple places around the app
// in our current workflow there is not many places where the once resolved company
// would be changed (intentionally) so you can assume that in most cases this provider will be set once
// on first page render & the data should stay the same throughout the whole ordering process
// as of now though, the SS part (that fires the Q) is re-run on each page transition
// so the data will actually change and if that is a problem, consider adding back some memo
// *
var _createContext = createContext("ResolvedCompany"),
    _createContext2 = _slicedToArray(_createContext, 3),
    Provider = _createContext2[0],
    useResolvedCompanyCtx = _createContext2[1],
    useResolvedCompanyUNSAFE = _createContext2[2]; // this context should be used on most of the pages
// but for pages that are not using it (eg. Error pages) we need to allow empty value
// in such case, the provider will not be rendered at all (to ensure the defined type)
// ! make sure those pages that do not fill the provider are not using it as well ! (otherwise expect thrown error about reading context that is not in the component tree)


/**
 * global provider of the resolved company (brand/branch)
 * use `useResolvedCompany` hook to access that info anywhere in the app
 */
export var ResolvedCompanyProvider = function ResolvedCompanyProvider(_ref) {
  var children = _ref.children,
      contextValue = _ref.contextValue;

  if (!contextValue) {
    return /*#__PURE__*/_jsx(_Fragment, {
      children: children
    });
  }

  return /*#__PURE__*/_jsx(Provider, {
    value: contextValue,
    children: children
  });
};
export { useResolvedCompanyCtx, useResolvedCompanyUNSAFE };